import { Component, OnDestroy } from '@angular/core';
import { Observable, shareReplay } from "rxjs";
import { PublicUserInfo } from "../../../models/user";
import {AsyncPipe, DatePipe, DecimalPipe, NgForOf, NgIf} from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
import { UserService } from 'src/app/services/user.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Title } from '@angular/platform-browser';
import {PersonReviewsComponent} from "../../../components/review/person-reviews/person-reviews.component";

@Component({
    selector: 'app-person-info',
    imports: [
        AsyncPipe,
        DatePipe,
        NgIf,
        DecimalPipe,
        MatIcon,
        MatProgressSpinner,
        NgForOf,
        PersonReviewsComponent
    ],
    templateUrl: './public-profile.component.html'
})
export class PublicProfileComponent implements OnDestroy {

  person$: Observable<PublicUserInfo>;
  userId: string;
  avatarUrl: string | null = null;
  avatarLoaded: boolean = false;
  fiveStars: number[];
  public showReviews: boolean = false;

  constructor(private userService: UserService,
              private activateRoute: ActivatedRoute,
              router: Router,
              pageTitle: Title) {
    let paramUserId = this.activateRoute.snapshot.paramMap.get('id');
    this.userId = paramUserId != null ? paramUserId : '';

    if (this.userId === '') {
      router.navigateByUrl('/404');
    }
    this.fiveStars = Array(5).fill(1).map((x, i) => i + 1);

    this.person$ = this.userService.getPublicUserInfo(this.userId).pipe(shareReplay(1));
    this.loadAvatarImage(this.userId);
    this.person$.subscribe({
      next: response => {
        pageTitle.setTitle($localize`${response.name} : public profile`);
        this.showReviews = response.reviewCount > 0;
      },
      error: (error) => {
        console.error(error);
        router.navigateByUrl('/404');
      }
    });
  }

  ngOnDestroy(): void {
    if(this.avatarUrl != null) {
      URL.revokeObjectURL(this.avatarUrl);
    }
  }

  private loadAvatarImage(userId: string) {
    this.userService.getAvatarImage(userId).subscribe({
      next: (response) => {
        if(response.body != null) {
          this.avatarUrl = URL.createObjectURL(response.body);
        }
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        this.avatarLoaded = true;
      }
    });
  }
  showIcon(index: number, rating: number) {
    if (rating >= index + 1) {
      return '/assets/icons/star-filled.svg';
    } else if (rating >= index + 0.5) {
        return '/assets/icons/star-half-filled.svg';
    } else {
      return '/assets/icons/star-non-filled.svg';
    }
  }
}
